import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { To, Link } from 'react-router';

export const CellLayout = styled(Box, { name: 'CellLayout' })(({ theme }) => ({
  width: '100%',
  paddingLeft: theme.spacing(16),
}));

export const CellLayoutRow = styled('div')(({ theme }) => {
  const fontSize = theme.typography.tablePrimary?.fontSize ?? '0.8125rem';
  const lineHeight = theme.typography.tablePrimary?.lineHeight ?? 1.38;

  const height = Number(fontSize.toString().split('rem')[0]) * Number(lineHeight) + 'rem';

  return {
    height,
  };
});

const CellLayoutTypography = styled(Typography)({
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
}) as typeof Typography;

export const CellLayoutSecondaryTypography = ({ children }: { children?: React.ReactNode }) => (
  <CellLayoutTypography
    variant="tableSecondary"
    color="text.secondary"
    component="div"
    data-testid="secondaryText"
  >
    {children}
  </CellLayoutTypography>
);

export const CellLayoutPrimaryTypography = ({ children }: { children?: React.ReactNode }) => (
  <CellLayoutTypography
    variant="tablePrimary"
    color="text.primary"
    component="div"
    data-testid="primaryText"
  >
    {children}
  </CellLayoutTypography>
);

export const CellLayoutLinkTypography = ({
  children,
  to,
  state,
}: {
  children?: React.ReactNode;
  to: To;
  state?: any;
}) => (
  <CellLayoutTypography component={Link} variant="tableLink" to={to} state={state}>
    {children}
  </CellLayoutTypography>
);

export const CellLayoutPrimaryLinkTypography = ({
  children,
  to,
  state,
}: {
  children?: React.ReactNode;
  to: To;
  state?: any;
}) => (
  <CellLayoutTypography
    component={Link}
    variant="tableLink"
    data-testid="primaryText"
    to={to}
    state={state}
  >
    {children}
  </CellLayoutTypography>
);
